import { useTranslation } from '@thoughtspot/i18n';
import { Alert, } from '@thoughtspot/radiant-react/widgets/alert';
import { Button } from '@thoughtspot/radiant-react/widgets/button';
import { Link } from '@thoughtspot/radiant-react/widgets/link';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import cx from 'classnames';
import React, { useState } from 'react';
import { ActionButtons, LearnMoreConfig, Mode } from '../constants';
import { CreateModal } from '../create-modal';
import styles from './header.module.scss';
export const HeaderComponent = ({ actions, extraActions, modernLayout = false, title, subTitle, mode = Mode.VIEW, learnMoreKey, titleSize = 'medium', askBackConfirm = false, isFormModified = false, pageName, banner, isFullWidth = false, actionHandler, buttonType, tabIndex, }) => {
    const { t } = useTranslation();
    const [backConfirm, setBackConfirm] = useState(false);
    const handleAction = (type) => {
        if (actionHandler) {
            switch (type) {
                case ActionButtons.BACK:
                    if (askBackConfirm && isFormModified) {
                        setBackConfirm(true);
                    }
                    else {
                        actionHandler(type);
                    }
                    break;
                default:
                    actionHandler(type);
                    break;
            }
        }
    };
    const renderLearnMore = () => {
        const learnMore = LearnMoreConfig[learnMoreKey] || undefined;
        if (learnMore) {
            return (React.createElement(Link, { href: learnMore.url, target: learnMore.newWindow ? '_blank' : undefined, className: styles.learnMore, rel: "noreferrer", tabIndex: 0 }, t(`${learnMore.text}`)));
        }
        return null;
    };
    const onDismiss = () => {
        setBackConfirm(false);
    };
    const onConfirm = () => {
        actionHandler(ActionButtons.BACK);
    };
    const headerClasses = cx(styles.header, {
        [styles.view]: mode === Mode.VIEW,
        [styles.subHeading]: titleSize === 'medium' && mode === Mode.VIEW,
    });
    const subTitleClasses = cx(styles.subTitle, {
        [styles.notFullWidth]: !isFullWidth,
    });
    const actionButtons = actions?.map(action => action.type ? (React.createElement("div", { className: styles.actionButton, key: action.title },
        React.createElement(Button, { text: `${action.title}`, type: buttonType || 'secondary', key: action.type, isDisabled: action.isDisabled || false, onClick: () => handleAction(action.type) }))) : null) ?? null;
    const descriptionBlock = subTitle && (React.createElement(Typography, { variant: "body-normal", color: Colors.grayLight, noMargin: true },
        subTitle,
        " \u00A0",
        learnMoreKey && renderLearnMore()));
    const actionsBlock = extraActions ? (React.createElement("div", { className: styles.actionsGroup },
        extraActions,
        actionButtons)) : (actionButtons);
    if (modernLayout) {
        return (React.createElement(React.Fragment, null,
            backConfirm && (React.createElement(CreateModal, { pageName: pageName, action: "back", onDismiss: onDismiss, onConfirm: onConfirm })),
            (descriptionBlock || actionsBlock) && mode === Mode.VIEW && (React.createElement("div", { className: cx(headerClasses, styles.modernHeaderRow) },
                React.createElement("div", { className: styles.modernDescription }, descriptionBlock),
                actionsBlock)),
            banner && React.createElement(Alert.Banner, { ...banner })));
    }
    return (React.createElement(React.Fragment, null,
        backConfirm && (React.createElement(CreateModal, { pageName: pageName, action: "back", onDismiss: onDismiss, onConfirm: onConfirm })),
        React.createElement("div", { className: headerClasses },
            React.createElement(Typography, { variant: titleSize === 'large' ? 'h2' : 'p-large-bold', className: styles.headerTitle }, title),
            actionsBlock),
        banner && React.createElement(Alert.Banner, { ...banner }),
        subTitle && mode === Mode.VIEW && (React.createElement("div", { className: subTitleClasses }, descriptionBlock))));
};
export const Header = React.memo(HeaderComponent);
//# sourceMappingURL=header.js.map